import { render, staticRenderFns } from "./TestGroup.vue?vue&type=template&id=76e46ee0&scoped=true&"
import script from "./TestGroup.vue?vue&type=script&lang=js&"
export * from "./TestGroup.vue?vue&type=script&lang=js&"
import style0 from "./TestGroup.vue?vue&type=style&index=0&id=76e46ee0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e46ee0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard,VCardActions,VCardText})
